import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@lmc-env/environment';

export interface LockedAccount {
	id: number;
	uuid: string;
	ipAddress: string;
	username: string;
	attempts: number;
	lockedUntil: Date;
	firstAttemptAt: Date;
	lastAttemptAt: Date;
}

export interface LockedAccountsResponse {
	success: boolean;
	data: LockedAccount[];
	count: number;
}

export interface UnlockAccountResponse {
	success: boolean;
	message: string;
}

@Injectable({
	providedIn: 'root',
})
export class LoginAttemptsService {
	private readonly baseUrl = `${environment.DO_URL}/v1/admin`;

	constructor(private http: HttpClient) {}

	/**
	 * Get all currently locked accounts
	 */
	getLockedAccounts(): Observable<LockedAccountsResponse> {
		return this.http.get<LockedAccountsResponse>(
			`${this.baseUrl}/locked-accounts`
		);
	}

	/**
	 * Unlock a specific account by UUID
	 */
	unlockAccount(uuid: string): Observable<UnlockAccountResponse> {
		return this.http.delete<UnlockAccountResponse>(
			`${this.baseUrl}/locked-accounts/${uuid}`
		);
	}
}
